{
  "header": {
    "eyebrow": "Registration Administration",
    "title": "Manage QCA",
    "description": "Review registered QCAs, track approval status, and monitor mapped capacity, PSS coverage, generator count, and unit inventory from a single table."
  },
  "stats": [
    {
      "label": "Total QCAs",
      "value": "17",
      "icon": "\u2318",
      "tone": "blue"
    },
    {
      "label": "Active QCAs",
      "value": "16",
      "icon": "\u25ce",
      "tone": "green"
    },
    {
      "label": "Inactive QCAs",
      "value": "1",
      "icon": "\u25cc",
      "tone": "red"
    },
    {
      "label": "Pending Approval",
      "value": "0",
      "icon": "\u25f7",
      "tone": "amber"
    },
    {
      "label": "Total Capacity",
      "value": "34,350",
      "suffix": "MW",
      "icon": "\u26a1",
      "tone": "violet"
    },
    {
      "label": "Total PSS",
      "value": "116",
      "icon": "\u2302",
      "tone": "blue"
    },
    {
      "label": "Total Generators",
      "value": "485",
      "icon": "\u25a6",
      "tone": "green"
    },
    {
      "label": "Total Units",
      "value": "720",
      "icon": "\u25eb",
      "tone": "amber"
    }
  ],
  "filters": {
    "status": [
      "All",
      "Active",
      "Inactive"
    ],
    "approvalStatus": [
      "All",
      "Approved",
      "Rejected"
    ],
    "state": [
      "All",
      "Maharashtra"
    ]
  },
  "rows": [
    {
      "code": "QCA-001",
      "name": "MH_MANIKARAN",
      "registeredAddress": "Jalgaon, Maharashtra",
      "contactPerson": "Person 1",
      "mobile": "9832685825",
      "email": "qca1@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1100,
      "pssCount": 8,
      "generatorCount": 21,
      "unitCount": 31,
      "registrationDate": "03-Jan-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-002",
      "name": "MH_RECONNECT",
      "registeredAddress": "Nashik, Maharashtra",
      "contactPerson": "Person 2",
      "mobile": "9878594899",
      "email": "qca2@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1850,
      "pssCount": 7,
      "generatorCount": 21,
      "unitCount": 31,
      "registrationDate": "06-Feb-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-003",
      "name": "MH_STATKRAFT",
      "registeredAddress": "Kolhapur, Maharashtra",
      "contactPerson": "Person 3",
      "mobile": "9819257142",
      "email": "qca3@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1550,
      "pssCount": 10,
      "generatorCount": 21,
      "unitCount": 31,
      "registrationDate": "09-Mar-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-004",
      "name": "MH_VEDANJAY",
      "registeredAddress": "Kolhapur, Maharashtra",
      "contactPerson": "Person 4",
      "mobile": "9884241246",
      "email": "qca4@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1350,
      "pssCount": 6,
      "generatorCount": 21,
      "unitCount": 31,
      "registrationDate": "12-Apr-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-005",
      "name": "MH_KREATE",
      "registeredAddress": "Satara, Maharashtra",
      "contactPerson": "Person 5",
      "mobile": "9882338658",
      "email": "qca5@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 950,
      "pssCount": 9,
      "generatorCount": 21,
      "unitCount": 31,
      "registrationDate": "15-May-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-006",
      "name": "MH_TPREL",
      "registeredAddress": "Mumbai, Maharashtra",
      "contactPerson": "Person 6",
      "mobile": "9865231132",
      "email": "qca6@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1950,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "18-Jun-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-007",
      "name": "MH_CLEAN",
      "registeredAddress": "Mumbai, Maharashtra",
      "contactPerson": "Person 7",
      "mobile": "9879031263",
      "email": "qca7@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1600,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "21-Jul-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-008",
      "name": "MH_WALWHAN",
      "registeredAddress": "Nashik, Maharashtra",
      "contactPerson": "Person 8",
      "mobile": "9867854782",
      "email": "qca8@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1400,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "24-Aug-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-009",
      "name": "MH_MSEDCL",
      "registeredAddress": "Jalgaon, Maharashtra",
      "contactPerson": "Person 9",
      "mobile": "9877187263",
      "email": "qca9@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1250,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "27-Sep-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-010",
      "name": "MH_SHARDA",
      "registeredAddress": "Aurangabad, Maharashtra",
      "contactPerson": "Person 10",
      "mobile": "9883362339",
      "email": "qca10@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1500,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "02-Oct-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-011",
      "name": "MH_RATNAGIRI",
      "registeredAddress": "Satara, Maharashtra",
      "contactPerson": "Person 11",
      "mobile": "9816976485",
      "email": "qca11@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1000,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "05-Nov-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-012",
      "name": "MH_FERMI",
      "registeredAddress": "Aurangabad, Maharashtra",
      "contactPerson": "Person 12",
      "mobile": "9860491041",
      "email": "qca12@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1350,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "08-Dec-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-013",
      "name": "MH_UNILINK",
      "registeredAddress": "Solapur, Maharashtra",
      "contactPerson": "Person 13",
      "mobile": "9837182009",
      "email": "qca13@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1150,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "11-Jan-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-014",
      "name": "MH_BULDHANA",
      "registeredAddress": "Jalgaon, Maharashtra",
      "contactPerson": "Person 14",
      "mobile": "9878988835",
      "email": "qca14@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1400,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "14-Feb-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-015",
      "name": "MH_AVAADA_SUSTAIN",
      "registeredAddress": "Aurangabad, Maharashtra",
      "contactPerson": "Person 15",
      "mobile": "9821618298",
      "email": "qca15@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1350,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "17-Mar-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-016",
      "name": "MH_VARKUTE",
      "registeredAddress": "Nashik, Maharashtra",
      "contactPerson": "Person 16",
      "mobile": "9883802109",
      "email": "qca16@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 2200,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "20-Apr-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-017",
      "name": "MH_YAVAT",
      "registeredAddress": "Kolhapur, Maharashtra",
      "contactPerson": "Person 17",
      "mobile": "9876166061",
      "email": "qca17@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 2150,
      "pssCount": 5,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "23-May-2025",
      "approvalStatus": "Approved",
      "status": "Inactive"
    },
    {
      "code": "QCA-018",
      "name": "Wind Energy QCA 18",
      "registeredAddress": "Aurangabad, Maharashtra",
      "contactPerson": "Person 18",
      "mobile": "9813277890",
      "email": "qca18@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1500,
      "pssCount": 1,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "26-Jun-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-019",
      "name": "Solar Energy QCA 19",
      "registeredAddress": "Aurangabad, Maharashtra",
      "contactPerson": "Person 19",
      "mobile": "9866914956",
      "email": "qca19@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1750,
      "pssCount": 1,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "29-Jul-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    },
    {
      "code": "QCA-020",
      "name": "Hybrid Energy QCA 20",
      "registeredAddress": "Jalgaon, Maharashtra",
      "contactPerson": "Person 20",
      "mobile": "9857600573",
      "email": "qca20@msldc.in",
      "state": "Maharashtra",
      "totalCapacityMw": 1600,
      "pssCount": 1,
      "generatorCount": 20,
      "unitCount": 30,
      "registrationDate": "01-Aug-2025",
      "approvalStatus": "Approved",
      "status": "Active"
    }
  ],
  "pssCatalog": [
    {
      "code": "PSS-001",
      "name": "Ahmednagar PSS 1",
      "state": "Maharashtra",
      "installedCapacityMw": 200,
      "status": "Active"
    },
    {
      "code": "PSS-002",
      "name": "Solapur PSS 2",
      "state": "Maharashtra",
      "installedCapacityMw": 400,
      "status": "Active"
    },
    {
      "code": "PSS-003",
      "name": "Jalgaon PSS 3",
      "state": "Maharashtra",
      "installedCapacityMw": 200,
      "status": "Active"
    },
    {
      "code": "PSS-004",
      "name": "Kolhapur PSS 4",
      "state": "Maharashtra",
      "installedCapacityMw": 100,
      "status": "Active"
    },
    {
      "code": "PSS-005",
      "name": "Jalgaon PSS 5",
      "state": "Maharashtra",
      "installedCapacityMw": 150,
      "status": "Active"
    },
    {
      "code": "PSS-006",
      "name": "Solapur PSS 6",
      "state": "Maharashtra",
      "installedCapacityMw": 600,
      "status": "Active"
    },
    {
      "code": "PSS-007",
      "name": "Nashik PSS 7",
      "state": "Maharashtra",
      "installedCapacityMw": 500,
      "status": "Active"
    },
    {
      "code": "PSS-008",
      "name": "Amravati PSS 8",
      "state": "Maharashtra",
      "installedCapacityMw": 250,
      "status": "Active"
    },
    {
      "code": "PSS-009",
      "name": "Kolhapur PSS 9",
      "state": "Maharashtra",
      "installedCapacityMw": 250,
      "status": "Active"
    },
    {
      "code": "PSS-010",
      "name": "Amravati PSS 10",
      "state": "Maharashtra",
      "installedCapacityMw": 400,
      "status": "Active"
    }
  ],
  "qcaPssMappings": {
    "QCA-001": [
      {
        "pssCode": "PSS-001",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-025",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-049",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-073",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-097",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-014",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-046",
        "mappedOn": "03-Jan-2025"
      },
      {
        "pssCode": "PSS-082",
        "mappedOn": "03-Jan-2025"
      }
    ],
    "QCA-002": [
      {
        "pssCode": "PSS-002",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-026",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-050",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-074",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-098",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-017",
        "mappedOn": "06-Feb-2025"
      },
      {
        "pssCode": "PSS-065",
        "mappedOn": "06-Feb-2025"
      }
    ],
    "QCA-003": [
      {
        "pssCode": "PSS-003",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-027",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-051",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-075",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-099",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-020",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-044",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-068",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-092",
        "mappedOn": "09-Mar-2025"
      },
      {
        "pssCode": "PSS-116",
        "mappedOn": "09-Mar-2025"
      }
    ],
    "QCA-004": [
      {
        "pssCode": "PSS-004",
        "mappedOn": "12-Apr-2025"
      },
      {
        "pssCode": "PSS-028",
        "mappedOn": "12-Apr-2025"
      },
      {
        "pssCode": "PSS-052",
        "mappedOn": "12-Apr-2025"
      },
      {
        "pssCode": "PSS-076",
        "mappedOn": "12-Apr-2025"
      },
      {
        "pssCode": "PSS-100",
        "mappedOn": "12-Apr-2025"
      },
      {
        "pssCode": "PSS-013",
        "mappedOn": "12-Apr-2025"
      }
    ],
    "QCA-005": [
      {
        "pssCode": "PSS-005",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-029",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-053",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-077",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-101",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-024",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-048",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-072",
        "mappedOn": "15-May-2025"
      },
      {
        "pssCode": "PSS-096",
        "mappedOn": "15-May-2025"
      }
    ],
    "QCA-006": [
      {
        "pssCode": "PSS-006",
        "mappedOn": "18-Jun-2025"
      },
      {
        "pssCode": "PSS-030",
        "mappedOn": "18-Jun-2025"
      },
      {
        "pssCode": "PSS-054",
        "mappedOn": "18-Jun-2025"
      },
      {
        "pssCode": "PSS-078",
        "mappedOn": "18-Jun-2025"
      },
      {
        "pssCode": "PSS-102",
        "mappedOn": "18-Jun-2025"
      }
    ],
    "QCA-007": [
      {
        "pssCode": "PSS-007",
        "mappedOn": "21-Jul-2025"
      },
      {
        "pssCode": "PSS-031",
        "mappedOn": "21-Jul-2025"
      },
      {
        "pssCode": "PSS-055",
        "mappedOn": "21-Jul-2025"
      },
      {
        "pssCode": "PSS-079",
        "mappedOn": "21-Jul-2025"
      },
      {
        "pssCode": "PSS-103",
        "mappedOn": "21-Jul-2025"
      }
    ],
    "QCA-008": [
      {
        "pssCode": "PSS-008",
        "mappedOn": "24-Aug-2025"
      },
      {
        "pssCode": "PSS-032",
        "mappedOn": "24-Aug-2025"
      },
      {
        "pssCode": "PSS-056",
        "mappedOn": "24-Aug-2025"
      },
      {
        "pssCode": "PSS-080",
        "mappedOn": "24-Aug-2025"
      },
      {
        "pssCode": "PSS-104",
        "mappedOn": "24-Aug-2025"
      }
    ],
    "QCA-009": [
      {
        "pssCode": "PSS-009",
        "mappedOn": "27-Sep-2025"
      },
      {
        "pssCode": "PSS-033",
        "mappedOn": "27-Sep-2025"
      },
      {
        "pssCode": "PSS-057",
        "mappedOn": "27-Sep-2025"
      },
      {
        "pssCode": "PSS-081",
        "mappedOn": "27-Sep-2025"
      },
      {
        "pssCode": "PSS-105",
        "mappedOn": "27-Sep-2025"
      }
    ],
    "QCA-010": [
      {
        "pssCode": "PSS-010",
        "mappedOn": "02-Oct-2025"
      },
      {
        "pssCode": "PSS-034",
        "mappedOn": "02-Oct-2025"
      },
      {
        "pssCode": "PSS-058",
        "mappedOn": "02-Oct-2025"
      },
      {
        "pssCode": "PSS-082",
        "mappedOn": "02-Oct-2025"
      },
      {
        "pssCode": "PSS-106",
        "mappedOn": "02-Oct-2025"
      }
    ],
    "QCA-011": [
      {
        "pssCode": "PSS-011",
        "mappedOn": "05-Nov-2025"
      },
      {
        "pssCode": "PSS-035",
        "mappedOn": "05-Nov-2025"
      },
      {
        "pssCode": "PSS-059",
        "mappedOn": "05-Nov-2025"
      },
      {
        "pssCode": "PSS-083",
        "mappedOn": "05-Nov-2025"
      },
      {
        "pssCode": "PSS-107",
        "mappedOn": "05-Nov-2025"
      }
    ],
    "QCA-012": [
      {
        "pssCode": "PSS-012",
        "mappedOn": "08-Dec-2025"
      },
      {
        "pssCode": "PSS-036",
        "mappedOn": "08-Dec-2025"
      },
      {
        "pssCode": "PSS-060",
        "mappedOn": "08-Dec-2025"
      },
      {
        "pssCode": "PSS-084",
        "mappedOn": "08-Dec-2025"
      },
      {
        "pssCode": "PSS-108",
        "mappedOn": "08-Dec-2025"
      }
    ],
    "QCA-013": [
      {
        "pssCode": "PSS-013",
        "mappedOn": "11-Jan-2025"
      },
      {
        "pssCode": "PSS-037",
        "mappedOn": "11-Jan-2025"
      },
      {
        "pssCode": "PSS-061",
        "mappedOn": "11-Jan-2025"
      },
      {
        "pssCode": "PSS-085",
        "mappedOn": "11-Jan-2025"
      },
      {
        "pssCode": "PSS-109",
        "mappedOn": "11-Jan-2025"
      }
    ],
    "QCA-014": [
      {
        "pssCode": "PSS-014",
        "mappedOn": "14-Feb-2025"
      },
      {
        "pssCode": "PSS-038",
        "mappedOn": "14-Feb-2025"
      },
      {
        "pssCode": "PSS-062",
        "mappedOn": "14-Feb-2025"
      },
      {
        "pssCode": "PSS-086",
        "mappedOn": "14-Feb-2025"
      },
      {
        "pssCode": "PSS-110",
        "mappedOn": "14-Feb-2025"
      }
    ],
    "QCA-015": [
      {
        "pssCode": "PSS-015",
        "mappedOn": "17-Mar-2025"
      },
      {
        "pssCode": "PSS-039",
        "mappedOn": "17-Mar-2025"
      },
      {
        "pssCode": "PSS-063",
        "mappedOn": "17-Mar-2025"
      },
      {
        "pssCode": "PSS-087",
        "mappedOn": "17-Mar-2025"
      },
      {
        "pssCode": "PSS-111",
        "mappedOn": "17-Mar-2025"
      }
    ],
    "QCA-016": [
      {
        "pssCode": "PSS-016",
        "mappedOn": "20-Apr-2025"
      },
      {
        "pssCode": "PSS-040",
        "mappedOn": "20-Apr-2025"
      },
      {
        "pssCode": "PSS-064",
        "mappedOn": "20-Apr-2025"
      },
      {
        "pssCode": "PSS-088",
        "mappedOn": "20-Apr-2025"
      },
      {
        "pssCode": "PSS-112",
        "mappedOn": "20-Apr-2025"
      }
    ],
    "QCA-017": [
      {
        "pssCode": "PSS-017",
        "mappedOn": "23-May-2025"
      },
      {
        "pssCode": "PSS-041",
        "mappedOn": "23-May-2025"
      },
      {
        "pssCode": "PSS-065",
        "mappedOn": "23-May-2025"
      },
      {
        "pssCode": "PSS-089",
        "mappedOn": "23-May-2025"
      },
      {
        "pssCode": "PSS-113",
        "mappedOn": "23-May-2025"
      }
    ],
    "QCA-018": [
      {
        "pssCode": "PSS-018",
        "mappedOn": "26-Jun-2025"
      },
      {
        "pssCode": "PSS-042",
        "mappedOn": "26-Jun-2025"
      },
      {
        "pssCode": "PSS-066",
        "mappedOn": "26-Jun-2025"
      },
      {
        "pssCode": "PSS-090",
        "mappedOn": "26-Jun-2025"
      },
      {
        "pssCode": "PSS-114",
        "mappedOn": "26-Jun-2025"
      }
    ],
    "QCA-019": [
      {
        "pssCode": "PSS-019",
        "mappedOn": "01-Jul-2025"
      },
      {
        "pssCode": "PSS-043",
        "mappedOn": "01-Jul-2025"
      },
      {
        "pssCode": "PSS-067",
        "mappedOn": "01-Jul-2025"
      },
      {
        "pssCode": "PSS-091",
        "mappedOn": "01-Jul-2025"
      },
      {
        "pssCode": "PSS-115",
        "mappedOn": "01-Jul-2025"
      }
    ],
    "QCA-020": [
      {
        "pssCode": "PSS-020",
        "mappedOn": "04-Aug-2025"
      },
      {
        "pssCode": "PSS-044",
        "mappedOn": "04-Aug-2025"
      },
      {
        "pssCode": "PSS-068",
        "mappedOn": "04-Aug-2025"
      },
      {
        "pssCode": "PSS-092",
        "mappedOn": "04-Aug-2025"
      },
      {
        "pssCode": "PSS-116",
        "mappedOn": "04-Aug-2025"
      }
    ],
    "QCA-021": [
      {
        "pssCode": "PSS-021",
        "mappedOn": "07-Sep-2025"
      },
      {
        "pssCode": "PSS-045",
        "mappedOn": "07-Sep-2025"
      },
      {
        "pssCode": "PSS-069",
        "mappedOn": "07-Sep-2025"
      },
      {
        "pssCode": "PSS-093",
        "mappedOn": "07-Sep-2025"
      }
    ],
    "QCA-022": [
      {
        "pssCode": "PSS-022",
        "mappedOn": "10-Oct-2025"
      },
      {
        "pssCode": "PSS-046",
        "mappedOn": "10-Oct-2025"
      },
      {
        "pssCode": "PSS-070",
        "mappedOn": "10-Oct-2025"
      },
      {
        "pssCode": "PSS-094",
        "mappedOn": "10-Oct-2025"
      }
    ],
    "QCA-023": [
      {
        "pssCode": "PSS-023",
        "mappedOn": "13-Nov-2025"
      },
      {
        "pssCode": "PSS-047",
        "mappedOn": "13-Nov-2025"
      },
      {
        "pssCode": "PSS-071",
        "mappedOn": "13-Nov-2025"
      },
      {
        "pssCode": "PSS-095",
        "mappedOn": "13-Nov-2025"
      }
    ],
    "QCA-024": [
      {
        "pssCode": "PSS-024",
        "mappedOn": "16-Dec-2025"
      },
      {
        "pssCode": "PSS-048",
        "mappedOn": "16-Dec-2025"
      },
      {
        "pssCode": "PSS-072",
        "mappedOn": "16-Dec-2025"
      },
      {
        "pssCode": "PSS-096",
        "mappedOn": "16-Dec-2025"
      }
    ]
  }
}
